import React from 'react';
import { Link } from 'react-router';
import * as UserActions from '../actions/user';
import { connect } from 'react-redux';
import Progress from './layout/Progress.react';
import { FormattedMessage } from 'react-intl';

class Logout extends React.Component {

    componentDidMount() {
        // call dispatch
        let { dispatch } = this.props;
        dispatch(UserActions.doLogout());
    }

    render() {

        const { user } = this.props;

        if (user.userId !== null) {
            return <Progress progressText='TEXT_PROGRESS_LOGOUT' />

        }

        return (
            <div id="logout">
                <div className="panel">
                    <div className="panel-body">
                        <h3><FormattedMessage id="TEXT_SUCCESSFUL_LOGOUT"/></h3>
                        <Link to={'/'} className="btn btn-primary"><FormattedMessage id="LABEL_TO_LOGIN"/></Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(state => ({ user: state.user }))(Logout);


// WEBPACK FOOTER //
// ./src/js/components/Logout.react.jsx